import { render, staticRenderFns } from "./PCWelfareLottery.vue?vue&type=template&id=0df6c3c3&"
import script from "./PCWelfareLottery.vue?vue&type=script&lang=js&"
export * from "./PCWelfareLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports